import { supabase } from "@/integrations/supabase/client";
import type { PageKey } from "@/config/pageRegistry";

export type { PageKey };

export interface PageVisibility {
  page_key: string;
  is_enabled: boolean;
  updated_at: string;
}

export const pageVisibilityService = {
  async getAll(): Promise<PageVisibility[]> {
    const { data, error } = await (supabase as any)
      .from("page_visibility")
      .select("page_key, is_enabled, updated_at");
    if (error) throw error;
    return (data ?? []) as PageVisibility[];
  },

  async setEnabled(pageKey: PageKey, isEnabled: boolean): Promise<void> {
    const { error } = await (supabase as any)
      .from("page_visibility")
      .upsert(
        { page_key: pageKey, is_enabled: isEnabled, updated_at: new Date().toISOString() },
        { onConflict: "page_key" }
      );
    if (error) throw error;
  },
};
